import { createContext, useState } from "react";
import _ from "lodash";
require("lodash");
export const InsightSelectionContext = createContext({
  selectedDestinationIds: [],
});


export function InsightSelectionProvider(props) {
  const [selectedDestinationIds, setSelectedDestinationIds] = useState([]);
  const selectDestination = (destinationId) => {
      setSelectedDestinationIds([destinationId]);
  };

  const addSelectedDestinations = (destinationIds) => {
      setSelectedDestinationIds(_.union(selectedDestinationIds, destinationIds));
  };

  const removeSelectedDestinations = (destinationIds) => {
      setSelectedDestinationIds(_.difference(selectedDestinationIds, destinationIds));
  };

  const clearSelectedDestinations = () => setSelectedDestinationIds([]);
  const areAnyDestinationsSelected = selectedDestinationIds.length > 0;
  const areMultipleDestinationsSelected = selectedDestinationIds.length > 1;
  const numDestinationsSelected = selectedDestinationIds.length;
  return (
    <InsightSelectionContext.Provider
      value={{
          selectedDestinationIds,
          selectDestination,
          setSelectedDestinations: setSelectedDestinationIds,
          addSelectedDestinations,
          removeSelectedDestinations,
          areAnyDestinationsSelected,
          clearSelectedDestinations,
          numDestinationsSelected,
          areMultipleDestinationsSelected,
      }}
    >
      {props.children}
    </InsightSelectionContext.Provider>
  );
}
export default InsightSelectionContext;
